/**
 * Returns whether v matches the BingMapsImageryMetadata type
 * @param v
 */
export function isBingMapsImageryMetadata(v) {
    if (typeof v !== "object")
        return false;
    if (typeof v.imageUrl === "undefined")
        return false;
    if (v.imageUrl !== null && typeof v.imageUrl !== "string")
        return false;
    if (typeof v.imageUrlSubdomains === "undefined")
        return false;
    if (v.imageUrlSubdomains !== null) {
        if (!Array.isArray(v.imageUrlSubdomains))
            return false;
        for (const i of v.imageUrlSubdomains) {
            if (typeof i !== "string")
                return false;
        }
    }
    if (typeof v.imageWidth === "undefined")
        return false;
    if (v.imageWidth !== null && typeof v.imageWidth !== "number")
        return false;
    if (typeof v.imageHeight === "undefined")
        return false;
    if (v.imageHeight !== null && typeof v.imageHeight !== "number")
        return false;
    if (typeof v.vintageStart === "undefined")
        return false;
    if (v.vintageStart !== null && typeof v.vintageStart !== "string")
        return false;
    if (typeof v.vintageEnd === "undefined")
        return false;
    if (v.vintageEnd !== null && typeof v.vintageEnd !== "string")
        return false;
    if (typeof v.zoomMin === "undefined")
        return false;
    if (typeof v.zoomMin !== "number")
        return false;
    if (typeof v.zoomMax === "undefined")
        return false;
    if (typeof v.zoomMax !== "number")
        return false;
    return true;
}
